import { useEffect, useState } from 'react';
import { ApiError } from '../../lib/api';
import { getTruck, type TruckDetail } from './trucks.api';

export type TruckRecordState =
  { status: 'loading' } | { status: 'loaded'; truck: TruckDetail } | { status: 'forbidden' } | { status: 'not_found' } | { status: 'error' };

function toErrorState(err: unknown): TruckRecordState {
  if (err instanceof ApiError && err.status === 403) return { status: 'forbidden' };
  if (err instanceof ApiError && err.status === 404) return { status: 'not_found' };
  return { status: 'error' };
}

/** One truck, fetched by id and re-fetchable after a mutation commits. */
export function useTruckRecord(id: string) {
  const [state, setState] = useState<TruckRecordState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;

    getTruck(id)
      .then((truck) => {
        if (!cancelled) setState({ status: 'loaded', truck });
      })
      .catch((err) => {
        if (!cancelled) setState(toErrorState(err));
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  async function reload(): Promise<void> {
    try {
      setState({ status: 'loaded', truck: await getTruck(id) });
    } catch (err) {
      setState(toErrorState(err));
    }
  }

  return { state, reload };
}
